import ApiUrl from './common/apiUrl';

import { fetchGet } from '../lib/network-requests';

export const getShopIds = async () => {
  const response = await fetchGet(`${ApiUrl.SHOPS}`);

  return response.json().then(data => {
    return data || {};
  });
};

export const getConfiguration = async (shop_id: string) => {
  const response = await fetchGet(`${ApiUrl.CONFIGS}?shop_id=${shop_id}`);

  return response.json().then(data => {
    return data || {};
  });
};
